module.exports = __webpack_public_path__ + "static/media/blog-hai-thumb@3x.306c4750.jpg";